import React, { Component, Fragment } from 'react';
import Navbar from '../components/Navbar';
import Breadcrumbs from '../components/Breadcrumbs';
import Timeline from '../components/Timeline';
import Image from '../components/Image';

export default class Page extends Component {
  render() {
    return (
      <Fragment>
        <title>PropertyHints: Walkthrough</title>
        <Navbar />

        <div id="features">
          <div className="container">
            <div className="row header">
              <div className="col-md-12" align="left">
                <Breadcrumbs
                  crumbs={[
                    {
                      url: '/walkthrough',
                      name: 'Walkthrough',
                    },
                  ]}
                />
                <h2 className="lead text-center">Walkthrough</h2>

                <div className="row">
                  <div className="col-sm-12 col-md-12" align="center">
                    <Image style={{ maxHeight: '200px' }} alt="Calculate" src="/assets/images/estate_icon.jpg" />
                    <hr />
                  </div>

                  <div className="col-sm-12 col-md-12">
                    <Timeline />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Fragment>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/Walkthrough.jsx